const Routes = {
  '/404': {
    title: '404 - Not Found',
    view: () => import('@pages/404/index.js'),
    needsLogin: false,
  },
  '/help': {
    title: 'Help',
    view: () => import('@pages/Help/index.js'),
    needsLogin: false,
  },
  '/login': {
    title: 'Login',
    view: () => import('@pages/Login/index.js'),
    needsLogin: false,
  },
  '/register': {
    title: 'Register',
    view: () => import('@pages/Register/index.js'),
    needsLogin: false,
  },
  '/resetpassword': {
    title: 'Forgot Password',
    view: () => import('@pages/Reset/password.js'),
    needsLogin: false,
  },
  '/projects': {
    title: 'Projects',
    view: () => import('@pages/Project/index.js'),
    needsLogin: false,
  },
  '/models/public': {
    title: 'Public Models',
    view: () => import('@pages/Models/Public/index.js'),
    needsLogin: false,
  },
  '/gallery': {
    title: 'O-Hive Gallery',
    view: () => import('@pages/Models/Ohive/index.js'),
    needsLogin: false,
  },
  '/viewer': {
    title: 'Viewer',
    view: () => import('@pages/Viewer/index.js'),
    needsLogin: false,
  },
  '/s': {
    title: 'Shared Model',
    view: () => import('@pages/Viewer/index.js'),
    needsLogin: false,
  },
  '/notifications': {
    title: 'Notifications',
    view: () => import('@pages/Notifications/index.js'),
    needsLogin: true,
  },
  '/settings': {
    title: 'Settings',
    view: () => import('@pages/Settings/index.js'),
    needsLogin: true,
  },
  '/orders': {
    title: 'SubmittedForms',
    view: () => import('@pages/SubmittedForms/index.js'),
    needsLogin: true,
  },
  '/emailverification': {
    title: 'Verify',
    view: () => import('@pages/Verify/mail.js'),
    needsLogin: false,
  },
  '/phoneverification': {
    title: 'Verify',
    view: () => import('@pages/Verify/phone.js'),
    needsLogin: false,
  },
  '/invitation': {
    title: 'Invite',
    view: () => import('@pages/Invite/index.js'),
    needsLogin: false,
  },
  '/privacy': {
    title: 'Privacy',
    view: () => import('@pages/Privacy/index.js'),
    needsLogin: false,
  },
  '/admin': {
    title: 'Admin',
    view: () => import('@pages/Admin/index.js'),
    needsLogin: true,
  },
  '/pricing': {
    title: 'Pricing',
    view: () => import('@pages/Pricing/index.js'),
    needsLogin: false,
  },
  '/llm': {
    title: 'LLM',
    view: () => import('@pages/LLM/index.js'),
    needsLogin: true,
  },
  '/chat': {
    title: 'Chat',
    view: () => import('@pages/Chat/entry.js'),
    needsLogin: true,
  },
  '/spatial-vision': {
    title: 'Spatial Vision',
    view: () => import('@pages/SpatialVision/index.js'),
    needsLogin: true,
  },
};

export default Routes;
